var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M988 667L988 695",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 988.5,
    cy: 662.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M983.987 662.19C983.987 658.283 987.288 655.117 991.358 655.117C991.943 655.117 992.511 655.184 993.056 655.308C991.742 654.48 990.187 654 988.519 654C983.814 654 980 657.806 980 662.5C980 667.194 983.814 671 988.519 671C990.814 671 992.895 670.093 994.427 668.62C993.492 669.032 992.454 669.263 991.358 669.263C987.288 669.263 983.987 666.096 983.987 662.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M997.402 661.6L997.37 659.146L995.535 660.719L993.304 660.056L994.112 662.337L992.765 664.381L995.1 664.218L996.499 666.144L997.133 663.763L999.345 662.909L997.402 661.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch5);
export default __webpack_public_path__ + "static/media/church_5.d36beb282970ede8af6ec0e42e91462d.svg";
export { ForwardRef as ReactComponent };